import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { XCircle, ArrowLeft } from 'lucide-react';

export default function PaymentCancelPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#16162a] flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center">
        <div className="w-20 h-20 bg-yellow-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-12 h-12 text-yellow-500" />
        </div>
        <h1 className="text-3xl font-bold text-white mb-4">Payment Cancelled</h1>
        <p className="text-gray-400 mb-8">
          Your payment was cancelled. No charges were made to your account.
        </p>
        <div className="space-y-4">
          <Button 
            onClick={() => navigate('/#pricing')}
            className="w-full bg-[#6D4AFF] hover:bg-[#5B3FD9] rounded-full py-6 font-bold shadow-[0_0_20px_rgba(109,74,255,0.3)] hover:shadow-[0_0_30px_rgba(109,74,255,0.5)] transition-all"
          >
            View Plans
          </Button>
          <Button 
            onClick={() => navigate('/')}
            variant="outline"
            className="w-full border-[#2d2d44] text-gray-300 hover:bg-[#2d2d44] rounded-full py-6 group"
          >
            <ArrowLeft className="w-5 h-5 mr-2 group-hover:-translate-x-1 transition-transform" />
            Back to Home
          </Button>
        </div>
      </div>
    </div>
  );
}
